// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OOuf","expireSoon":"styles_expireSoon__1x0Vs"};